module.exports = __webpack_public_path__ + "static/media/pricing-11.50748280.png";